import { Component, Input, OnInit } from "@angular/core";
import { ModalController } from "@ionic/angular";
import { ReportTask } from "../report-task.model";
import { ReportTaskService } from "../report-task.service";

@Component({
  selector: "app-report-task-modal",
  templateUrl: "./report-task-modal.component.html",
  styleUrls: ["./report-task-modal.component.scss"],
})
export class ReportTaskModalComponent implements OnInit {
  constructor(
    public modalController: ModalController,
    public reportTaskServ: ReportTaskService
  ) {}

  isError: boolean = false;
  errorStatus: number;
  editContractorModalOpened: boolean = false;


  @Input()
  task: ReportTask;

  ngOnInit() {
    // this.reportTaskServ
    //   .getReportTask(this.task.id.toString())
    //   .toPromise()
    //   .then((reportTask: ReportTask) => {
    //     this.reportTaskServ.reportTask = reportTask;
    //     this.showLoader = false;
    //   })
    //   .catch((error) => {
    //     this.isError = true;
    //     this.errorStatus = error.status;
    //   });
  }

  onEditContactorEvent(event) {
    this.editContractorModalOpened = event;
  }

  close() {
    this.modalController.dismiss();
  }
}
